/**
 * The message "topics" the Email Queue consumer dispatches on (its Handle_* switch
 * statement). Each one maps to a specific email template/handler on the backend.
 */
export const EMAIL_MESSAGE_TOPICS: string[] = [
  "LoansToSettle",
  "Test",
  "FFGExport",
  "CreditCorpExport",
  "Investor",
  "BrokerOperatorIntroduction",
  "Collections",
  "ChangeRequest",
  "Brokers",
  "BrokerLoginEmail",
  "LoanError",
  "CcrRun",
  "ResetPassword",
  "WelcomeToPortal",
  "SettlementResend",
  "LoanAssignedEmail",
  "PolicyExceptionApprovalEmail",
  "ArrearsNotificationToBrokers",
  "LoanThankYouEmail",
  "PendingBSReminderEmail",
  "LoanWithdrawWarningEmail",
  "WelcomeConditionallyApprovedBroker",
  "WelcomeConditionallyApprovedDirect",
  "CciReportEmail",
  "PostSettlementEmail",
  "AtCreditSense",
  "SettleLoanEmail",
  "RCTIEmail",
  "RemittanceAdviceEmail",
  "ApproveLoanEmail",
  "ApproveLoanEmailPandaDoc",
  "DeclineLoanEmail",
  "GenericEmail",
  "SubmitToFoxSymes",
  "SubmitToCRA",
  "AggregatorSettleLoanEmail",
  "TemplateEmail",
  "BrokerAccreditationEmail",
  "BrokerVerifyAccreditationDocusign",
  "AggregatorAccreditationSignEmail",
  "AccreditationCompleteEmailToDM",
  "LoanDocusignCompleteEmail",
  "LoanPandaDocCompleteClientEmail",
  "LoanPandaDocCompleteLendingConsultantEmail",
  "TrafficSummaryEmail",
  "MarketingCSVEmail",
  "LoanCreditSenseEmail",
  "BrokerAccredReport",
  "ArmBalanceRun",
  "SmsJobSummary",
  "HandoverBrokerAppToClient",
  "TrustpilotReminder",
  "BrokerReadyToSettle",
  "MMSGAppSubmission",
  "LoanWithdrawn",
  "CustomerLoanErrorEmail",
  "CCRFailedSFTP",
  "DocumentUploadedNotificationEmail",
  "LoanAssessmentQueuedEmail",
  "LoanDirectDebitChange",
  "PendingItemsEmail",
  "CreditApproveEmail",
  "AutoCreditApproveEmail",
  "OneTimePassword",
  "OneTimePasswordEmailChange",
  "OverrideVerificationRequestEmail",
  "SystemVerificationAlertEmail",
];
